import { createContext, useContext } from 'react';

import type { ExternalLinkClickHandler } from './ExternalLink.types';

export const ExternalLinkClickHandlerContext = createContext<ExternalLinkClickHandler | undefined>(undefined);

type UseExternalLinkClickHandlerContext = () => ExternalLinkClickHandler | undefined;
export const useExternalLinkClickHandlerContext: UseExternalLinkClickHandlerContext = () =>
  useContext(ExternalLinkClickHandlerContext);
